import React, { useState } from "react";
import { ChiTietTaiSan1 } from "./ChiTiet/ChiTietTaiSan";
export const BtnChiTietTaiSan = ({ taisan }) => {
  const [showChiTietTaiSan, setShowChiTietTaiSan] = useState(false);
  const handleCloseChiTietTaiSan = () => setShowChiTietTaiSan(false);
  const handleShowChiTietTaiSan = () => setShowChiTietTaiSan(true);
  const functionChiTietTaiSan = () => {
    setShowChiTietTaiSan(true);
  };

  return (
    <>
      <a
        onClick={functionChiTietTaiSan}
        href={() => false}
        className=" word-break"
      >
        {taisan.MaTaiSan}
      </a>
      {showChiTietTaiSan && (
        <ChiTietTaiSan1
          show={showChiTietTaiSan}
          taiSanId={taisan.TaiSanID}
          onHide={handleCloseChiTietTaiSan}
        ></ChiTietTaiSan1>
      )}
    </>
  );
};
